import { Card } from "@/components/ui/card";
import { Building2, TriangleAlert, Globe, History } from "lucide-react";
import { TESTIDS } from "@/constants/testIds";

const StatCard = ({ icon: Icon, label, value, testId, tone }) => {
  const tones = {
    info: "text-[hsl(201,96%,28%)] bg-[hsl(199,92%,94%)] border-[hsl(199,85%,86%)]",
    lead: "text-[hsl(var(--lead-fg))] bg-[hsl(var(--lead-bg))] border-[hsl(var(--lead-border))]",
    has: "text-[hsl(var(--has-fg))] bg-[hsl(var(--has-bg))] border-[hsl(var(--has-border))]",
    neutral: "text-[hsl(215,25%,30%)] bg-[hsl(210,30%,94%)] border-[hsl(214,20%,85%)]",
  };
  return (
    <Card
      data-testid={testId}
      className="p-4 flex items-center gap-3 border-border/80 shadow-[var(--shadow-card)] transition-shadow duration-150 hover:shadow-[0_1px_0_rgba(15,23,42,0.04),0_14px_40px_rgba(15,23,42,0.10)]"
    >
      <div className={`flex h-11 w-11 items-center justify-center rounded-lg border ${tones[tone]}`}>
        <Icon className="h-5 w-5" />
      </div>
      <div className="min-w-0">
        <div className="text-2xl font-heading font-bold leading-none tabular-nums">{value}</div>
        <div className="mt-1 text-xs text-muted-foreground truncate">{label}</div>
      </div>
    </Card>
  );
};

export const StatsCards = ({ summary }) => {
  const s = summary || { total: 0, leads: 0, with_website: 0, repeats: 0 };
  const hasRepeats = (s.repeats || 0) > 0;
  return (
    <div className={`grid grid-cols-2 gap-3 ${hasRepeats ? "lg:grid-cols-4" : "lg:grid-cols-3"}`}>
      <StatCard icon={Building2} label="Toplam İşletme" value={s.total} tone="info" testId={TESTIDS.statTotal} />
      <StatCard icon={TriangleAlert} label="Lead (Web sitesi yok)" value={s.leads} tone="lead" testId={TESTIDS.statLeads} />
      <StatCard icon={Globe} label="Web sitesi var" value={s.with_website} tone="has" testId={TESTIDS.statWithWebsite} />
      {hasRepeats && (
        <StatCard icon={History} label="Daha önce eklenen" value={s.repeats} tone="neutral" testId="stat-repeats" />
      )}
    </div>
  );
};
